import Component from "./component";
import { decodeHtml, generateClassName } from "./utils";
import { registerComponent } from "./jquery";
import { mmTextArea, mmTextAreaOptions } from "@/types";
import { prefix } from "./constants";
import { name } from "eslint-plugin-prettier/recommended";

class TextArea extends Component<mmTextAreaOptions> implements mmTextArea {
  private _dxTextArea!: DevExpress.ui.dxTextArea;

  constructor(element: HTMLElement, options?: mmTextAreaOptions) {
    super(element, options);
  let rawValue = this._options.value;

    let valueForDX: string | number | boolean | undefined;
    if (typeof rawValue === "string") {
      valueForDX = decodeHtml(rawValue); 
    } else if (typeof rawValue === "number" || typeof rawValue === "boolean") {
      valueForDX = rawValue;
    } else {
      valueForDX = undefined;
    }
    this._dxTextArea = ($(this._element) as any)
      .dxTextArea({
        value: valueForDX,
        placeholder: this._options.placeholder,
        inputAttr: this._options.inputAttr,
        minHeight: this._options.minHeight,
        maxLength: this._options.maxLength,
        readOnly: this._options.readOnly,
        stylingMode: this._options.style,
        name: this._options.name,
        autoResizeEnabled: this._options.autoResizeEnabled,
        disabled: this._options.disabled,
        maxHeight: this._options.maxHeight,
        width: this._options.width,
        height: this._options.height,
        onInitialized: this._options.onInitialized,
        onInput: this._options.onInput,
        onValueChanged:this._options.onValueChanged,
        onKeyUp:this._options.onKeyUp,
        elementAttr: {
          class: generateClassName("text-area", this._options.color!, this._options.size!, this._options.className),
          ...(this._options.attributes ?? {}),
        },
      })
      .dxTextArea("instance");
  }

  public get value(): string | number | Date {
    const val = this._dxTextArea.option("value");
    return val !== undefined ? val : "";
  }
  public set value(val: string | number | Date) {
    this._dxTextArea.option("value", val !== undefined && val !== null ? String(val) : "");
  }

  public get readOnly(): boolean {
    const val = this._dxTextArea.option("readOnly");
    return val !== undefined ? val : false;
  }
  public set readOnly(val: boolean) {
    this._dxTextArea.option("readOnly", val);
  }

  public get disabled(): boolean {
    const val = this._dxTextArea.option("disabled");
    return val !== undefined ? val : false;
  }
  public set disabled(val: boolean) {
    this._dxTextArea.option("disabled", val);
  }

  public get isEmpty(): boolean {
    const val = this.value;
    return val === undefined || val === null || val === "";
  }
  public set isEmpty(val: boolean) {
    if (val) {
      this.value = "";
    }
  }

  public getDefaults(): Partial<mmTextAreaOptions> {
    return {
      value: "",
      color: "default",
      size: "md",
      height: 90,
      readOnly: false,
      disabled: false,
      autoResizeEnabled: false,
    };
  }
}

registerComponent("mmTextArea", TextArea);

export default TextArea;
